// extracted by mini-css-extract-plugin
module.exports = {"pill":"_db10220"};